module.exports = function ($) {
    var $carousel = $(this).find('.elementor-products-carousel');
    if (!$carousel.length) {
        if (elementorFrontendConfig.isEditMode) {
            $(this).find('img[data-src]').each(function() {
                $(this).attr('src', $(this).data('src'));
            });
        }
        return;
    }

    var respondTo = 'window';

    if (elementorFrontendConfig.isEditMode) {
        respondTo = 'iframe-window';
    }

    var savedOptions = $carousel.data('slider_options'),
        defaultOptions = {
            respondTo: respondTo,
            infinite: false,
            autoplaySpeed: 4500,
            rtl: parseInt(elementorFrontendConfig.is_rtl) ? true : false,
            rows: savedOptions.itemsPerColumn,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: savedOptions.slidesToShowTablet,
                        slidesToScroll: savedOptions.slidesToShowTablet
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: savedOptions.slidesToShowMobile,
                        slidesToScroll: savedOptions.slidesToShowMobile
                    }
                }
            ]
        },

        slickOptions = $.extend({}, defaultOptions, $carousel.data('slider_options'));

    $carousel.slick(slickOptions);

    if (elementorFrontendConfig.isEditMode) {
        $(window).on('changedDeviceMode', function () {
            $carousel.slick('getSlick').checkResponsive();
        });
    }

    $(document).on('shown.bs.tab', $(this).find('a[data-toggle="tab"]'), function (e) {
        prestashop.iqitLazyLoad.update();
    })


};
